import wizardEdit from './wizard-edit';

const routes = [...wizardEdit];

export default routes;
